<!--
2023-09-12 YTW 体育赛事竞猜
-->
<template>
  <div class="main-content"
       :style="getContent() === 1
    ? { backgroundImage: 'url(' + require('../../assets/images/sportsBetting/bg.webp') + ')' }
    : { background: '#151515' }">
    <TopBack :title="$t('lang.sportsBetting.title')" :handelBack="goBackHome"/>
    <div class="nav-wrapper">
      <div class="nav">
        <div
          v-for="navItem in navItems"
          class="nav-item"
          :class="{'active':currentNavItem == navItem}"
          :key="navItem"
          @click="chooseNavItem(navItem)"
        >
          <div>{{ navItem }}</div>
          <div class="itemBottom" v-show="currentNavItem == navItem"/>
        </div>
      </div>
    </div>
    <div class="bannerBox">
      <div class="banner-bottom">
        <Swipe
          :auto="5000"
          v-if="bannerList&&bannerList.length > 0"
        >
          <SwipeItem
            v-for="(item, i) in bannerList"
            :key="'p' + i"
            v-if="checkBannerCondition(item.condition)"
          >
            <div class="carousel-item">
              <img
                :alt="item.Name"
                :src="item.Src"
                class="banner-image"
                @click="bannerAction(item.Path)"
              >
            </div>
          </SwipeItem>
        </Swipe>
      </div>
    </div>
    <!--    体育包赔    -->
    <div v-if="currentNavItem===$t('lang.sportsBetting.navItems')[0]">
      <div class="matchBox2">
        <div class="date-box">
          <span class="font">{{ $t('lang.sportsBetting.EventDuration') }}</span>
          <span class="date">{{
              formattedDateRange(championTeamData.DoubleRewardStartDate + ' - ' + championTeamData.DoubleRewardEndDate)
            }}</span>
        </div>
        <div class="game-box"
             :style="{ backgroundImage: 'url(' + require('../../assets/images/sportsBetting/gameBox.webp') + ')' }">
          <div class="icon-title"><img :src="icon1" alt=""/><span>{{ $t('lang.sportsBetting.Games') }}</span></div>
          <div class="games">
            <div class="left">
              <div class="game"
                   @click="fetchGame({ GameCode: 'sbs_sportsbook', GameProviderId: 5,GameNameEn:'SABA'  })">
                <div class="img"><img
                  src="https://betapp-images.s3.ap-northeast-1.amazonaws.com/Game/6ztsqg9dx0epukhlu6i2a2re9r0ccesaWX20250612-101806%402x.png"
                  alt=""></div>
                <div class="name">SABA</div>
              </div>
              <div class="game" @click="fetchGame({ GameCode: 'bti_sportsbook', GameProviderId: 5,GameNameEn:'BTI'  })">
                <div class="img"><img
                  src="https://betapp-images.s3.ap-northeast-1.amazonaws.com/Game/ae7wo5ro7th1d9aje5teefqicr68umawBTI%20Sportsbook.png"
                  alt=""></div>
                <div class="name">BTI</div>
              </div>
            </div>
            <div class="right" @click="gotoSports">Go></div>
          </div>
          <div class="bottom">
            <span class="line1">{{ $t('lang.sportsBetting.bottomLine1') }}</span>
            <span class="line2">{{ $t('lang.sportsBetting.bottomLine2') }}</span>
          </div>
        </div>
        <div class="event-box">
          <div class="icon-title"><img :src="icon2" class="img" alt=""/><span>{{
              $t('lang.sportsBetting.EventDetails')
            }}</span>
          </div>
          <div class="content" v-html="$t('lang.sportsBetting.events')"></div>
        </div>
        <div class="reward-box">
          <div class="icon-title"><img :src="icon3" class="img" alt=""/><span>{{
              $t('lang.sportsBetting.RewardClaim')
            }}</span>
          </div>
          <div class="content" v-html="$t('lang.sportsBetting.links')"></div>
          <div class="button" @click="openLink()">{{ $t('lang.common.submit') }}</div>
        </div>
      </div>
    </div>
    <!--    双重奖励    -->
    <div v-if="currentNavItem===$t('lang.sportsBetting.navItems')[1]">
      <div class="matchBox3">
        <div class="date-box">
          <span class="font">{{ $t('lang.sportsBetting.EventDuration') }}</span>
          <span class="date">{{
              formattedDateRange(championTeamData.DoubleRewardStartDate + ' - ' + championTeamData.DoubleRewardEndDate)
            }}</span>
        </div>
        <div class="game-box"
             :style="{ backgroundImage: 'url(' + require('../../assets/images/sportsBetting/gameBox.webp') + ')' }">
          <div class="icon-title"><img :src="icon1" alt=""/><span>{{ $t('lang.sportsBetting.Games') }}</span></div>
          <div class="games">
            <div class="left">
              <div class="game"
                   @click="fetchGame({ GameCode: 'sbs_sportsbook', GameProviderId: 5,GameNameEn:'SABA'  })">
                <div class="img"><img
                  src="https://betapp-images.s3.ap-northeast-1.amazonaws.com/Game/6ztsqg9dx0epukhlu6i2a2re9r0ccesaWX20250612-101806%402x.png"
                  alt=""></div>
                <div class="name">SABA</div>
              </div>
              <div class="game" @click="fetchGame({ GameCode: 'bti_sportsbook', GameProviderId: 5,GameNameEn:'BTI'  })">
                <div class="img"><img
                  src="https://betapp-images.s3.ap-northeast-1.amazonaws.com/Game/ae7wo5ro7th1d9aje5teefqicr68umawBTI%20Sportsbook.png"
                  alt=""></div>
                <div class="name">BTI</div>
              </div>
            </div>
            <div class="right" @click="gotoSports">Go></div>
          </div>
          <div class="bottom">
            <span class="line1">{{ $t('lang.sportsBetting.bottomLine1') }}</span>
            <span class="line2">{{ $t('lang.sportsBetting.bottomLine2') }}</span>
          </div>
        </div>
        <div class="event-box">
          <div class="icon-title"><img :src="icon2" alt=""/><span>{{
              $t('lang.betActivityRegularly.cashbackRewards')
            }}</span>
            <img class="x2" :src="x2" alt="" style="width: 13vw;height: auto;;margin:1vw 0 0 1vw"/>
          </div>
          <div class="content">{{ $t('lang.sportsBetting.RewardsText') }}</div>
          <div class="next"  @click="goto('BetActivityRegularly')">
            <div class="routeFonts">{{ $t('lang.sportsBetting.viewRebate') }}</div>
            <img :src="next" alt=""/>
          </div>
          <img class="shadowImg1" :src="shadow1" alt="" style="width: 26.666vw;height: auto"/>
        </div>
        <div class="event-box">
          <div class="icon-title"><img :src="icon3" alt=""/><span>{{ $t('lang.sportsBetting.Cashback') }}</span>
            <img class="x2" :src="x2" alt="" style="width: 13vw;height: auto;margin:1vw 0 0 1vw"/>
          </div>
          <div class="content" style="width: 63.888vw">{{ $t('lang.sportsBetting.CashbackText') }}</div>
          <div class="next" @click="goto('CashBack')">
            <div class="routeFonts">{{ $t('lang.sportsBetting.viewCashback') }}</div>
            <img :src="next" alt=""/>
          </div>
          <img class="shadowImg2" :src="shadow2" alt="" style="width: 26.666vw;height: auto"/>
        </div>
      </div>
    </div>
    <!--    tg    -->
    <div v-if="currentNavItem===$t('lang.sportsBetting.navItems')[2]" class="tgBenefits">
      <div class="top">
        <img :src="textLine" alt="textLine"/>
        <span>{{ $t('lang.sportsBetting.moreBenefits') }}</span>
      </div>
      <div class="center">
        <div class="row">
          <div class="type0">
            <img :src="type0" alt=""/>
            <div class="font" :key="index" v-for="(font,index) in  $t('lang.sportsBetting.benefits0') ">{{ font }}</div>
          </div>
          <div class="type1">
            <img :src="type1" alt=""/>
            <div class="font" :key="index" v-for="(font,index) in  $t('lang.sportsBetting.benefits1') ">{{ font }}</div>
          </div>
        </div>
        <div class="row">
          <div class="type2">
            <img :src="type2" alt=""/>
            <div class="font" :key="index" v-for="(font,index) in  $t('lang.sportsBetting.benefits2') ">{{ font }}</div>
          </div>
          <div class="type3">
            <img :src="type3" alt=""/>
            <div class="font" :key="index" v-for="(font,index) in  $t('lang.sportsBetting.benefits3') ">{{ font }}</div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="button" @click="socialHref('https://t.me/PGEbet555')">
          <img :src="tg" alt="tg"/>
          <span>{{ $t('lang.sportsBetting.followNow1') }}</span>
        </div>
        <div class="button" @click="socialHref('https://t.me/PGEbet_agent')">
          <img :src="tg" alt="tg"/>
          <span>{{ $t('lang.sportsBetting.followNow2') }}</span>
        </div>
      </div>
    </div>
    <div class="bottom-rules" v-if="getContent()===0">
      <div class="bubble-box">
        <div class="titleWhite" style="margin-bottom: 2vw">{{ $t('lang.inviteFriends.bubbleTitle') }}</div>
        <div class="bubbleContent" v-for="(item,index) in $t('lang.sportsBetting.rules'+ getContent())" :key="index">
          <div style="margin-bottom: 2vw">{{ item }}</div>
        </div>
      </div>
    </div>
    <div :class="{'panel-Mask': showPanel}" @click="closePanel"></div>
    <div class="panel" v-if="showPanel">
      <div class="grips"></div>
      <div class="panel_background">
        <div class="titleWhite">

          <span>{{ currentNavItem }}</span>
        </div>
        <p class="subtitle">{{ $t('lang.sportsBetting.quizClues') }}</p>
        <!--        冠军      -->
        <div class="team-wrapper2" v-if="currentNavItem===$t('lang.sportsBetting.navItems')[0]">
          <div class="teamImg">
            <img :src="grayCircle" alt="" class="imgBk">
            <img :src="currentGuessChampion.Src" class="imgInner" alt="">
          </div>
          <div class="teamChoose">
            <p>{{ currentGuessChampion.Name }}</p>
            <p style="font-size: 3.88vw;color: #626262">{{
                championTeamData.Date.replace(/-/g, '/').substring(championTeamData.Date.length - 5) + ' ' + championTeamData.Time.substring(0, 5)
              }}</p>
          </div>
        </div>
        <!--    每日    -->
        <div class="team-wrapper" v-if="currentNavItem===$t('lang.sportsBetting.navItems')[1]">
          <div :class="currentSelect.index === 0?'choose-item active-choose':'choose-item'"
               @click="guess(currentGame,0)">
            <div class="pie">
              <img :src="currentGame.Team1Src" alt="">
              <div class="circle"
                   :style="{backgroundImage:'url('+require('../../assets/images/sportsBetting/pie.svg')+')'}">
                <CircleProgress
                  id="pie0"
                  :radius="5"
                  :progress="(currentGame.GuessInfo.Team1Count/(currentGame.GuessInfo.Team1Count+currentGame.GuessInfo.Team2Count+currentGame.GuessInfo.Team3Count))*100"
                  :isAnimation="true"
                  barColor="#F23042"
                  backgroundColor="#444444"
                >
                </CircleProgress>
              </div>
            </div>
            <div class="team-name">{{ currentGame.Team1Name }}</div>
            <div class="guess-bottom" style="background:#2E1815;">
              <p style="color: #F23042;">{{ $t('lang.sportsBetting.count') }}:</p>
              <p style="color: #F23042;">{{ currentGame.GuessInfo.Team1Count }}</p>
            </div>
          </div>
          <div :class="currentSelect.index === 1?'choose-item active-choose':'choose-item'"
               @click="guess(currentGame,1)">
            <div class="pie">
              <img :src="x" alt="">
              <div class="circle"
                   :style="{backgroundImage:'url('+require('../../assets/images/sportsBetting/pie.svg')+')'}">
                <CircleProgress
                  id="pie1"
                  :radius="5"
                  :progress="(currentGame.GuessInfo.Team3Count/(currentGame.GuessInfo.Team1Count+currentGame.GuessInfo.Team2Count+currentGame.GuessInfo.Team3Count))*100"
                  :isAnimation="true"
                  barColor="#D9D9D9"
                  backgroundColor="#444444"
                >
                </CircleProgress>
              </div>
            </div>
            <div class="team-name">{{ $t('lang.sportsBetting.draw') }}</div>
            <div class="guess-bottom" style="background:#232323;">
              <p style="color: #AEAEAE;">{{ $t('lang.sportsBetting.count') }}:</p>
              <p style="color: #AEAEAE;">{{ currentGame.GuessInfo.Team3Count }}</p>
            </div>
          </div>
          <div :class="currentSelect.index === 2?'choose-item active-choose':'choose-item'"
               @click="guess(currentGame,2)">
            <div class="pie">
              <img :src="currentGame.Team2Src" alt="">
              <div class="circle"
                   :style="{backgroundImage:'url('+require('../../assets/images/sportsBetting/pie.svg')+')'}">
                <CircleProgress
                  id="pie2"
                  :radius="5"
                  :progress="(currentGame.GuessInfo.Team2Count/(currentGame.GuessInfo.Team1Count+currentGame.GuessInfo.Team2Count+currentGame.GuessInfo.Team3Count))*100"
                  :isAnimation="true"
                  barColor="#48CA5E"
                  backgroundColor="#444444"
                >
                </CircleProgress>
              </div>
            </div>
            <div class="team-name">{{ currentGame.Team2Name }}</div>
            <div class="guess-bottom" style="background:#1F3523;">
              <p style="color: #48CA5E;">{{ $t('lang.sportsBetting.count') }}:</p>
              <p style="color: #48CA5E;">{{ currentGame.GuessInfo.Team2Count }}</p>
            </div>
          </div>
        </div>
        <div class="tips">
          <p style="font-weight: 400">{{ $t('lang.sportsBetting.mayWin') }}
            :
            <b v-if="currentNavItem===$t('lang.sportsBetting.navItems')[0]">{{
                $t('lang.account.currencyType')
              }}{{
                getPriceNumber()
              }}</b>
          </p>
          <p style="font-weight: 400">
            <img :src="warn">
            <span>{{ $t('lang.sportsBetting.actualConditions') }}</span>
          </p>
        </div>
        <div :class="guessBtnCss" @click="submitGuess">{{ $t('lang.sportsBetting.guessNow') }}</div>
      </div>
    </div>
    <div :class="{'panel-Mask': showAlert}"></div>
    <div class="share-alert" v-if="showAlert">
      <img class="close" :src="closeImg" @click="showAlert=false" alt="">
      <div class="title" v-if="alertType===1">{{ $t('lang.sportsBetting.lastStep') }}</div>
      <div class="title" v-if="alertType===2">
        <p v-for="(item,index) in $t('lang.sportsBetting.guessSuccess')"
           :key="index">{{ item }}</p>
      </div>
      <div class="title" v-if="alertType===3">{{ $t('lang.sportsBetting.chooseWay') }}</div>
      <div class="subTitle">
        <p v-for="(sub,i) in guessDesc" :key="i">
          {{ sub }}
        </p>
      </div>
      <div class="subTip" v-if="alertType!==3">
        <hr color="#626262" size="3" align="center" width="22%">
        <div style="margin-top: -3.5vw;">{{ $t('lang.sportsBetting.chooseWay') }}</div>
        <hr color="#626262" size="3" align="center" width="22%">
      </div>
      <div class="otherIcon">
        <div><img class="whatsapp" :src="whatsapp" @click="whatsappClick">
          <div>WhatsApp</div>
        </div>
        <div><img class="telegram" :src="telegram" @click="telegramClick">
          <div>Telegram</div>
        </div>
        <div><img class="facebook" :src="facebook" @click="facebookClick">
          <div>Facebook</div>
        </div>
        <div><img class="copyLink" @click="copyLinkClick" :src="copyLink">
          <div>Copy Link</div>
        </div>
      </div>
    </div>
    <div :class="{'panel-Mask': rankRewardShow}"></div>
    <div class="rank-reward" v-if="rankRewardShow">
      <div class="cancel-btn" @click="rankRewardShow=false">
        <img :src="cancelWhite" alt="cancel">
      </div>
      <div class="reward-table">
        <div class="title">
          <div>{{ $t('lang.sportsBetting.Ranking') }}</div>
          <div>{{ $t('lang.sportsBetting.Prizes') }}</div>
        </div>
        <div class="tbody">
          <div class="tr">
            <div><img :src="rank1" alt=""/></div>
            <div>₹177,777</div>
          </div>
          <div class="tr">
            <div><img :src="rank2" alt=""/></div>
            <div>₹111,111</div>
          </div>
          <div class="tr">
            <div><img :src="rank3" alt=""/></div>
            <div>₹77,777</div>
          </div>
          <div class="tr">
            <div>4</div>
            <div>₹17,777</div>
          </div>
          <div class="tr">
            <div>5</div>
            <div>₹11,111</div>
          </div>
          <div class="tr">
            <div>6</div>
            <div>₹7,777</div>
          </div>
          <div class="tr">
            <div>7</div>
            <div>₹1,777</div>
          </div>
          <div class="tr">
            <div>8</div>
            <div>₹1,111</div>
          </div>
          <div class="tr">
            <div>9</div>
            <div>₹777</div>
          </div>
          <div class="tr">
            <div>10</div>
            <div>₹777</div>
          </div>
        </div>
      </div>
    </div>
    <div class="lastWeekList" v-show="lastWeekShow">
      <div class="closeLastWeekButton"><img :src="closeLastWeekImg" alt="" @click="closeLastWeek"/></div>
      <div class="lastWeekModal">
        <div class="shadow"/>
        <div class="top">
          <span class="title">{{ $t('lang.shareFiesta.date') }}{{ lastWeekSpan }}</span>
        </div>
        <div class="lastRankList">
          <div class="RankRow" style="height: 10vw;">
            <div class="label" style="font-weight: 700;font-size: 3.888vw;">{{
                $t('lang.sportsBetting.Ranking')
              }}
            </div>
            <div class="name" style="font-weight: 700;font-size: 3.888vw;">
              {{ $t('lang.sportsBetting.playerName') }}
            </div>
          </div>
          <div class="RankRow" :id="'rank'+index" style="background-color: #323438" v-for="(rank,index) in lastWeekRank"
               :key="index">
            <div class="rankImg">
              <img v-if="rank.Rank===1" :src="rank1" alt="">
              <img v-else-if="rank.Rank===2" :src="rank2" alt="">
              <img v-else-if="rank.Rank===3" :src="rank3" alt="">
              <span v-else>{{ rank.Rank }}</span>
            </div>
            <div class="name">{{ rank.UserName }}</div>
          </div>
        </div>
        <div class="myRankLastWeek">
          <div class="rankImg">
            <img v-if="myLastWeekRank===1" :src="rank1" alt="">
            <img v-else-if="myLastWeekRank===2" :src="rank2" alt="">
            <img v-else-if="myLastWeekRank===3" :src="rank3" alt="">
            <span v-else-if="myLastWeekRank===0">-</span>
            <span v-else>{{ myLastWeekRank }}</span>
          </div>
          <div class="name" style="font-weight: 700;font-size: 3.888vw;">
            {{ $t('lang.sportsBetting.you') }}
          </div>
        </div>
      </div>
    </div>
    <ConfirmWin v-if="this.$store.state.confirmWinShow" :hintText="balanceNotEnoughHint"
                :confirmToDo="confirmGotoPage"></ConfirmWin>
  </div>
</template>

<script>
import ConfirmWin from '@/components/ConfirmWin/confirmWithOneButton'
import TopBack from '@/components/TopBack/index'
import copyLink from '@/assets/images/invite/copyLink.svg'
import facebook from '@/assets/images/invite/facebook.svg'
import telegram from '@/assets/images/invite/telegram.svg'
import whatsapp from '@/assets/images/invite/whatsapp.svg'
import x from '@/assets/images/sportsBetting/x.svg'
import vs from '@/assets/images/sportsBetting/vs.svg'
import warn from '@/assets/images/sportsBetting/warn.svg'
import rank1 from '@/assets/images/sportsBetting/rank1.svg'
import rank2 from '@/assets/images/sportsBetting/rank2.svg'
import rank3 from '@/assets/images/sportsBetting/rank3.svg'
import closeImg from '@/assets/images/sportsBetting/close.svg'
import alarm from '@/assets/images/sportsBetting/alarm.svg'
import teamBack from '@/assets/images/sportsBetting/teamBack.svg'
import grayCircle from '@/assets/images/sportsBetting/grayCircle.svg'
import cancelWhite from '@/assets/images/common/cancelWhite.svg'
import request from '@/service'
import {checkBannerCondition, LogUtils} from '@/utils'
import {Swipe, SwipeItem, Toast} from 'mint-ui'
import CircleProgress from 'vue-circleprogressbar'
import config from '../../../static/config/config'
import lockFill from '@/assets/images/sportsBetting/lockFill.webp'
import x2 from '@/assets/images/sportsBetting/x2.svg'
import icon1 from '@/assets/images/sportsBetting/icon1.webp'
import icon2 from '@/assets/images/sportsBetting/icon2.webp'
import icon3 from '@/assets/images/sportsBetting/icon3.webp'
import game1 from '@/assets/images/sportsBetting/9w.webp'
import game2 from '@/assets/images/sportsBetting/saba.webp'
import game3 from '@/assets/images/sportsBetting/betNow.webp'
import shadow1 from '@/assets/images/sportsBetting/shadow1.webp'
import shadow2 from '@/assets/images/sportsBetting/shadow2.webp'
import type0 from '@/assets/images/sportsBetting/type0.webp'
import type1 from '@/assets/images/sportsBetting/type1.webp'
import type2 from '@/assets/images/sportsBetting/type2.webp'
import type3 from '@/assets/images/sportsBetting/type3.webp'
import textLine from '@/assets/images/sportsBetting/textLine.webp'
import closeLastWeekImg from '@/assets/images/sportsBetting/closeLastWeek.svg'
import tg from '@/assets/images/sportsBetting/tg.svg'
import next from '@/assets/images/sportsBetting/next.svg'

export default {
  name: 'SportsBetting',
  computed: {},
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      navItems: this.$t('lang.sportsBetting.navItems'),
      currentNavItem: this.$t('lang.sportsBetting.navItems')[0],
      x,
      vs,
      warn,
      rank1,
      rank2,
      rank3,
      closeImg,
      alarm,
      x2,
      icon1,
      icon2,
      icon3,
      game1,
      game2,
      game3,
      shadow1,
      shadow2,
      next,
      type0,
      type1,
      type2,
      type3,
      tg,
      textLine,
      lockFill,
      copyLink,
      facebook,
      telegram,
      whatsapp,
      teamBack,
      grayCircle,
      cancelWhite,
      closeLastWeekImg,
      checkBannerCondition,
      gameInfo: {},
      playGame: {},
      balanceNotEnoughHint: this.$t('lang.home.creditNotEnough'),
      showGame: false,
      shareCode: '',
      showAlert: false,
      rankRewardShow: false,
      lastWeekShow: false,
      guessBtnCss: 'yellow-button',
      alertType: 1,
      guessDesc: [],
      showPanel: false,
      bannerList: [],
      allBannerData: {
        BetInsuranceBanner: [],
        DoubleRewardsBanner: [],
        TGBenefitsBanner: []
      },
      currentGame: {},
      currentSelect: {
        index: 0,
        count: 50
      },
      currentGuessChampion: {},
      matchList: [],
      otherRoundList: [],
      championTeamData: {},
      championTeamList: [],
      betAmount: 0,
      currentRank: 0,
      rankLock: false,
      ranks: [],
      lastWeekRank: [],
      myLastWeekRank: '',
      lastWeekSpan: ''
    }
  },
  components: {
    TopBack,
    Swipe,
    SwipeItem,
    CircleProgress,
    ConfirmWin
  },
  watch: {
    '$store.state.locale': function (n, o) {
      this.navItems = this.$t('lang.sportsBetting.navItems')
      this.currentNavItem = this.$t('lang.sportsBetting.navItems')[0]
      this.bannerList = this.allBannerData.BetInsuranceBanner
    }
  },
  mounted () {
    if (this.userInfo && this.userInfo.UserId) {
      this.fetchAccount()
    }
    const userId = this.userInfo ? this.userInfo.UserId : ''
    LogUtils.saveUserEventParams('SportsBettingPage', userId, localStorage.getItem('visitorCode'))
    let shareCode = this.$route.query.s
    if (shareCode) {
      LogUtils.setShareCode(shareCode)
      this.someoneComeOn(shareCode)
    }
    let tabIndex = this.$route.query.index
    if (tabIndex) {
      this.currentNavItem = this.$t('lang.sportsBetting.navItems')[tabIndex]
    }
    this.fetchChampionData()
  },
  updated () {
  },
  methods: {
    socialHref (href) {
      window.open(href)
    },
    openLink () {
      window.open('https://forms.gle/FrEEzpxRKMnqyroP6')
    },
    chooseNavItem: function (currentNavItem) {
      if (this.currentNavItem === currentNavItem) {
        return
      }
      if (currentNavItem === this.$t('lang.sportsBetting.navItems')[0]) {
        this.fetchChampionData()
        this.bannerList = this.allBannerData.BetInsuranceBanner
      } else if (currentNavItem === this.$t('lang.sportsBetting.navItems')[1]) {
        this.bannerList = this.allBannerData.DoubleRewardsBanner
      } else if (currentNavItem === this.$t('lang.sportsBetting.navItems')[2]) {
        this.bannerList = this.allBannerData.TGBenefitsBanner
      }
      this.currentNavItem = currentNavItem
    },
    gotoSports () {
      this.$router.push({name: 'Home', query: {category: 'SportsGames'}}) // 跳体育分类
    },
    goBackHome () {
      this.$router.push('/Home')
    },
    goto (path) {
      this.$router.push('/' + path)
    },
    fetchGame (game) { // 原来的fetchGame
      if (this.userInfo) {
        if (this.$store.state.banUserId.includes(this.userInfo.UserId)) {
          Toast(this.$t('lang.home.gameMaintenancePrompt'))
          return
        }
        const url = '/innovation/game/getgameurl'
        const data = {
          userId: this.userInfo.UserId || '',
          gameCode: game.GameCode,
          gameProviderId: game.GameProviderId,
          deviceWidth: document.body.clientWidth,
          lang: localStorage.getItem('locale'),
          internation: this.$store.state.internation,
          campaignId: localStorage.getItem('cid'),
          localVersion: config.version,
          localApkVersion: localStorage.getItem('apkV') ? localStorage.getItem('apkV') : '1.0.0'
        }
        request('post', url, data).then(res => {
          if (res.Url) {
            const gameInfo = {
              gameUrl: res.Url,
              gameImg: game.ThumbnailUrl,
              gameName: game.GameNameEn
            }
            this.$store.commit('setShowGame', true)
            this.$store.commit('setGameInfo', gameInfo)
          } else {
            Toast(this.$t('lang.home.gameMaintenancePrompt'))
          }
        }).catch(() => {
          Toast(Toast(this.$t('lang.home.gameMaintenancePrompt')))
        })
      } else {
        this.$router.push('/Login')
      }
    },
    confirmGotoPage () {
      this.$router.push('/Deposit')
    },
    fetchChampionData () {
      let data = {}
      if (this.userInfo && this.userInfo.UserId) {
        data.UserId = this.userInfo.UserId
      } else {
        data.UserId = null
      }
      this.bannerList = []
      request('post', 'innovation/match/get_champion_guess', data, false).then(res => {
        this.championTeamData = res
        // this.championTeamList = res.TeamInfo
        const {
          BetInsuranceBanner,
          DoubleRewardsBanner,
          TGBenefitsBanner
        } = res

        // 可以将提取的属性赋值给 allBannerData
        this.allBannerData = {
          BetInsuranceBanner,
          DoubleRewardsBanner,
          TGBenefitsBanner
        }
        this.bannerList = this.allBannerData.BetInsuranceBanner
      })
    },
    close () {
      this.showGame = false
    },
    someoneComeOn (shareCode) {
      if (shareCode) {
        request('post', 'innovation/match/share_line', {ShareCode: shareCode}, false).then(res => {
        })
      }
    },
    fetchRankData () {
      let data = {}
      if (this.userInfo && this.userInfo.UserId) {
        data.UserId = this.userInfo.UserId
      } else {
        data.UserId = null
      }
      request('post', 'innovation/match/get_sport_rank', data, false).then(res => {
        this.betAmount = res.BetAmount
        this.currentRank = res.CurrentRank
        this.ranks = res.Ranks
        this.rankLock = res.IsLock
      })
    },
    fetchLastWeekRank () {
      let data = {}
      if (this.userInfo && this.userInfo.UserId) {
        data.UserId = this.userInfo.UserId
      } else {
        data.UserId = null
      }
      request('post', 'innovation/match/get/last_week/sport_rank', data, true).then(res => {
        if (res) {
          this.lastWeekRank = res.Ranks
          this.myLastWeekRank = res.CurrentRank
          this.lastWeekSpan = this.formattedDateRange(res.StartDate + ' - ' + res.EndDate)
        }
      })
    },
    showLastWeek () {
      this.lastWeekShow = true
    },
    closeLastWeek () {
      this.lastWeekShow = false
    },
    formattedDateRange (dateRange) {
      if (!dateRange) {
        return ''
      }
      // 获取日期范围
      const [startDate, endDate] = dateRange.split(' - ')

      // 格式化日期
      const formatDate = (dateStr) => {
        const date = new Date(dateStr)
        const month = date.getMonth() + 1
        const day = date.getDate()
        return `${date.getFullYear()}/${month}/${day}`
      }

      return `${formatDate(startDate)} - ${formatDate(endDate)}`
    },
    findAbridge (item) {
      item = item.indexOf('0') === 0 ? item.substring(1, item.length) : item
      if (item && item.indexOf('.') > -1) {
        let name = ''
        switch (item.split('.')[0]) {
          case '1':
            name = 'JAN'
            break
          case '2':
            name = 'FEB'
            break
          case '3':
            name = 'MAR'
            break
          case '4':
            name = 'APR'
            break
          case '5':
            name = 'MAY'
            break
          case '6':
            name = 'JUN'
            break
          case '7':
            name = 'JUL'
            break
          case '8':
            name = 'AUG'
            break
          case '9':
            name = 'SEP'
            break
          case '10':
            name = 'OCT'
            break
          case '11':
            name = 'NOV'
            break
          case '12':
            name = 'DEC'
            break
        }
        return item.split('.')[1] + ' ' + name
      } else {
        return item
      }
    },
    nullClick () {
    },
    bannerAction (path) {
      if (path && (path.indexOf('PlayGame=') > -1)) {
        let gameStr = path.split('=')[1]
        let param = JSON.parse(gameStr)
        this.fetchGame(param)
      } else if (path) {
        this.$router.push({path: path})
      }
    },
    /****
     * 记录用户玩过的游戏到本地 2022-09-24 HHY
     * 记录用户玩过的最新游戏到本地 2022-09-27 HHY
     * */
    recordPlayedGame (game) {
      let storage = localStorage.getItem('PlayHistory')
      let histories = JSON.parse(storage)
      if (histories === null) {
        histories = []
      }
      var playedGame = {
        GameCode: game.GameCode,
        GameCategory: this.showType,
        PlayTime: new Date()
      }

      const len = histories.length
      if (len > 0) {
        let found = histories.find(item => item.GameCode === playedGame.GameCode && item.GameCategory === playedGame.GameCategory)
        if (found) {
          // console.log('hhy playtime：' + JSON.stringify(found))
          found.PlayTime = new Date()
        } else {
          var indx = histories.findIndex(f => f.GameCategory === playedGame.GameCategory)
          if (indx >= 0) { // 只有找到同类的游戏时
            histories.splice(indx, 1) // 删除玩过的同类游戏，这样只记录用户最新玩过的游戏
          }
          histories.push(playedGame)
        }
      } else {
        histories.push(playedGame)
      }
      localStorage.setItem('PlayHistory', JSON.stringify(histories))
    },
    seeReward () {
      this.rankRewardShow = true
    },
    getContent () {
      const index = this.navItems.findIndex((item) => {
        return item === this.currentNavItem
      })
      return index
    },
    closePanel () {
      this.showPanel = false
    },
    guess (match, index) {
      this.currentSelect = {index: index}
      if (index === 0) {
        this.currentSelect.count = match.GuessInfo.Team1Count
      } else if (index === 1) {
        this.currentSelect.count = match.GuessInfo.Team3Count
      } else if (index === 2) {
        this.currentSelect.count = match.GuessInfo.Team2Count
      }
      if (match.MatchExpired) {
        this.guessBtnCss = 'disabled-button'
      } else {
        this.guessBtnCss = 'yellow-button'
      }
      this.showPanel = true
      this.currentGame = match
    },
    getPriceNumber () {
      const num = this.currentGuessChampion.UserCount === 0 ? this.currentGuessChampion.Reward : (this.currentGuessChampion.Reward * this.currentGuessChampion.UserCount) / (this.currentGuessChampion.UserCount + 1)
      return num.toFixed(0)
    },
    fetchAccount () {
      let that = this
      const url = '/innovation/account/getuseraccount'
      const data = {
        userId: this.userInfo.UserId
      }
      request('post', url, data).then(res => {
        that.shareCode = res.InviteLink.replace('/Share', '/SportsBetting')
      }).catch(err => {
        console.log(err)
      })
    },
    msgFormat () {
      let welcomeMessage = this.$t('lang.sportsBetting.shareMsg')
      let index = this.shareCode.indexOf('/Share')
      if (index === -1) {
        index = this.shareCode.toLowerCase().indexOf('/share')
      }

      welcomeMessage = welcomeMessage.replace('{shareUrl}', this.shareCode)
      return welcomeMessage
    },
    telegramClick () {
      this.copyShares()
      let message = encodeURIComponent(this.msgFormat().replace(this.shareCode, ''))
      this.saveUserEvent('Telegram')
      const url = `https://t.me/share/url?url=` + this.shareCode.replace('&', '%26') + `&text=` + message
      window.open(url)
    },
    whatsappClick () {
      this.copyShares()
      let message = encodeURIComponent(this.msgFormat())
      this.saveUserEvent('WhatsApp')
      window.open(`https://wa.me/?text=${message}`, '_blank')
    },
    facebookClick () {
      this.copyShares()
      this.saveUserEvent('Facebook')
      window.open(`https://www.facebook.com/sharer.php?u=` + this.shareCode, '_blank')
    },
    copyShares () {
      let message = this.msgFormat()
      let copyBehavior = function (e) {
        e.clipboardData.setData('text/plain', message)
        e.preventDefault() // 阻止默认行为
      }
      document.addEventListener('copy', copyBehavior)
      document.execCommand('copy')
    },
    copyLinkClick () {
      this.copyShares()
      this.saveUserEvent('Link2')
      Toast(this.$t('lang.inviteFriends.success'))
    },
    saveUserEvent (val) { // 埋点
      const url = '/innovation/account/save/user/event'
      const data = {EventNameEN: val, UserUniqueId: this.userInfo.UserId}
      request('post', url, data, true).then(res => {
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.main-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 56px 0 0 0; // 2022-03-27 CHP Fix tab被topbar遮挡
  overflow-x: hidden;
  overflow-y: auto;
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;

  .rankBg {
    position: absolute;
    top: 50vw;
    left: 0;
    width: 100vw;
    height: 171.528vw;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 0;
  }

  .tgBg {
    position: absolute;
    top: 50vw;
    left: 0;
    width: 100vw;
    height: 179.444vw;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 0;
  }

  .nav-wrapper {
    margin: 4.1666vw auto 0 auto;
    width: 97vw;
    height: 12vw;

    .nav {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .nav-item {
        position: relative;
        width: 33.3333%;
        height: 12vw;
        padding: 0 1.2vw;
        text-align: center;
        font-family: Inter;
        font-weight: 600;
        font-size: 3.6vw;
        line-height: 3.6vw;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;

        .itemBottom {
          position: absolute;
          left: 50%;
          transform: translate(-50%);
          bottom: 0;
          width: 98%;
          height: .8333vw;
          border-radius: 1.8vw;
          background: #E4D9AA;
        }
      }

      .active {
        color: #E4D9AA;
      }
    }
  }

  .bannerBox {
    margin: 1vw auto 3vw auto;
    width: 100vw;
    height: 38.889vw;
    overflow-y: visible;
    z-index: 2;

    .banner-bottom {
      height: 68vw;
      overflow: visible;

      .banner-image {
        width: 100%;
        height: auto;
      }
    }
  }

  .matchBox {
    position: relative;
    width: 89.444vw;
    background-color: #161616;
    margin: auto;
    z-index: 6;

    .lockBox {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.8);
      z-index: 1;
      border-radius: 0 0 1.9vw 1.9vw;
      display: flex;
      align-items: center;
      justify-content: center;

      .lockFill {
        width: 70vw;
        height: max-content;

        img {
          position: relative;
          left: 50%;
          transform: translate(-50%);
          width: 14.444vw;
          height: auto;
        }

        .text {
          width: 100%;
          font-family: Inter;
          font-weight: 800;
          font-size: 3.8vw;
          line-height: 4.2vw;
          text-align: center;
          text-transform: capitalize;
          color: #FFFFFF;
        }
      }
    }

    .match {
      position: relative;
      width: 90vw;
      border-radius: 1.9vw;
      margin: 3vw auto;
      background-color: #1E1E1E;
      min-height: 105vw;
      max-height: 132vw;

      .match-center {
        height: 45vw;
        border-top: 0.833vw solid #303030;
        display: flex;
        justify-content: space-between;
        overflow: hidden;

        .center_item {
          position: relative;
          width: 31vw;
          height: 100%;
          overflow: visible;
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;

          .center-text {
            position: relative;
            top: 50%;
            transform: translateY(-50%);
            width: 100%;
            margin: auto;
            height: max-content;
            text-align: center;
            font-size: 5.833vw;
            font-weight: 400;
            line-height: 7.57vw;
            color: #FFFFFF;
          }

          .imgBk-Left {
            position: absolute;
            top: -2vw;
            left: -23.25vw;
            width: 46.5vw;
            height: 38.84vw;
            opacity: 0.1;
          }

          .imgBk-Center {
            position: absolute;
            top: 27%;
            left: -15%;
            width: 120%;
          }

          .imgBk-Right {
            position: absolute;
            top: -2vw;
            right: -23.25vw;
            width: 46.5vw;
            height: 38.84vw;
            opacity: 0.1;
          }

          .imgTeam {
            position: relative;
            left: 50%;
            transform: translate(-50%);
            max-width: 100%;
            height: 27.6vw;
            margin-top: 5.5vw;
          }

          .text {
            position: absolute;
            bottom: 2vw;
            width: 100%;
            height: 9vw;
            text-align: center;
            font-size: 3.88vw;
            line-height: 4.5vw;
            font-weight: 400;
            color: #FFFFFF;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }

      .match-bottom {
        position: relative;
        top: 0;
        padding: 2vw 0 6vw 0;

        .bottom-title {
          width: 100%;
          font-size: 4.166vw;
          font-weight: 500;
          line-height: 10vw;
          height: 6.5vw;
          text-align: center;
          color: #5F5F5F;
        }

        .redAndBlue {
          margin: auto;
          width: 83.333vw;
          height: max-content;
          background: #212324;
          border-radius: 1.388vw;
          box-shadow: 0 5px 11.600000381469727px 0 #000000A3, 1px 1px 1.100000023841858px 0 #FFFFFF17 inset;

          .container {
            padding-bottom: 2vw;
            width: 100%;
            height: max-content;
            display: flex;
            justify-content: space-between;

            .choose-item {
              position: relative;
              width: 32%;
              height: max-content;
              text-align: center;
              overflow: visible;

              img:first-of-type {
                position: absolute;
                height: 130%;
                width: 100%;
                top: -15%;
                left: 0;
                opacity: 0.1;
              }

              img:last-of-type {
                position: absolute;
                height: 130%;
                width: 100%;
                top: -15%;
                right: 0;
                opacity: 0.1;
              }

              p {
                font-weight: 400;
                font-size: calc(2.75vw + 3px);
                line-height: calc(3.75vw + 3px);
                color: #000000;
              }

              .teamStyle {
                height: max-content;
                min-height: 17vw;
                color: #FFFFFF;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 5.277vw;
                font-weight: 900;
                line-height: 5vw;
                text-align: left;
                white-space: pre-wrap;
                overflow-wrap: break-word;
              }

              .memberCount {
                margin-top: 1vw;
                font-size: 3.611vw;
                font-weight: 700;
                letter-spacing: -0.01em;
                color: #787878;
              }

              .memberAccount {
                margin-top: 1vw;
                font-size: 4.444vw;
                font-weight: 900;
                letter-spacing: -0.03em;
                color: #FFFFFF;
              }
            }
          }
        }

        .myGuess {
          height: max-content;

          .guess-container {
            background-color: rgba(0, 0, 0, 0.0);
            position: relative;
            margin: 5vw auto 0 auto;
            width: 85vw;
            border: 1px solid #686868;
            height: max-content;
            border-radius: 1.111vw;

            .guess-row {
              width: 100%;
              display: flex;
              justify-content: space-between;
              padding: 2.5vw 0 2.5vw 2vw;
              font-size: 3.2vw;
              font-weight: 700;
              line-height: 3.35vw;
              letter-spacing: -0.02em;
              overflow: auto;

              .label {
                margin: 1vw auto;
                text-align: center;
                width: max-content;
                max-width: 18vw;
                height: 9vw;
                color: #A4A4A4;
                display: flex;
                align-items: center;
              }

              .content {
                margin: 0 0 1.5vw 0;
                font-size: 3.333vw;
                text-align: center;
                color: #FFFFFF;
                max-width: 18vw;
                height: 9.1vw;
                display: flex;
                justify-content: center;
                align-items: center;
                letter-spacing: -0.01em;
                font-weight: 400;
              }

              .guessTeam {
                font-size: 3.333vw;
              }
            }

            z-index: 1;
          }

          .btn-container {
            margin-top: 6vw;
            position: relative;
            width: 100%;
            height: 16.5vw;

            .shareBtn {
              position: absolute;
              top: 0;
              left: 50%;
              transform: translate(-50%);
              width: 85.194vw;
              height: 8.8889vw;
              border-radius: 1.111vw;
              line-height: 8.8889vw;
              text-align: center;
              background-color: #FFDD4A;
              color: #000000;
              letter-spacing: -0.025em;
              font-family: Arial;
              font-weight: 700;
              font-size: 3.8vw;
              text-transform: capitalize;
            }

            img {
              width: 70vw;
              position: absolute;
              bottom: 16vw;
              z-index: 0;
            }
          }
        }

        .teamContainer {
          margin: auto;
          width: 90vw;
          max-height: 88.5vw;
          overflow-x: hidden;
          overflow-y: auto;
          padding: 0 2.5vw;
          display: grid;
          justify-content: space-between;
          grid-template-columns: repeat(3, 1fr);
          z-index: 1;

          .team-item {
            position: relative;
            width: 23.055vw;
            height: 23.055vw;
            margin: 2.5vw auto;
            background-color: #282828;
            border-radius: 1.111vw;

            img {
              position: relative;
              left: 50%;
              transform: translate(-50%);
              margin-top: 1vw;
              max-width: 100%;
              height: 12.777vw;
            }

            .teamName {
              position: absolute;
              bottom: 1.5vw;
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              text-align: center;
              font-size: 2.9vw;
              height: 7vw;
              font-weight: 700;
              color: #FFFFFF;
            }
          }
        }

        .teamContainer::-webkit-scrollbar {
          display: none;
        }

      }

      .whoIsTheChampion {
        position: relative;
        width: 100%;
        height: max-content;
        padding: 5vw 0 0 0;

        .championTime {
          text-align: center;
          font-family: Inter;
          font-weight: 800;
          font-size: 5.555vw;
          color: #FFFFFF;
          margin: 0 auto;
        }

        .TimeTitle {
          margin: 5vw auto 0 auto;
          font-family: Inter;
          font-weight: 600;
          font-size: 4.444vw;
          line-height: 100%;
          text-transform: uppercase;
          text-align: center;
          color: #B3B3B3;
        }

        .timer {
          margin: 3vw auto 2vw auto;
          width: 78.333vw;
          height: 13.333vw;
          background: #0D0D0D;
          border-radius: 5px;

          .time-box {
            position: relative;
            top: 50%;
            transform: translateY(-50%);

            .timer-time {
              width: 100%;
              text-align: center;
              font-size: 8.5vw;
              color: #FFFFFF;
              letter-spacing: 0.75vw;
              font-weight: 400;
            }

            .timer-date {
              position: relative;
              left: 50%;
              transform: translate(-50%);
              display: flex;
              justify-content: space-between;
              margin-top: 2vw;
              padding: 0 8vw;
              width: 78.333vw;
              text-align: center;
              font-size: 5.833vw;
              height: 8vw;
              line-height: 8.5vw;
              border-radius: 4vw;
              color: #FFFFFF;
              font-weight: 800;

              .line {
                margin: 0 2vw;
                width: 0.5vw;
                height: 100%;
                background-position: center;
                background-repeat: no-repeat;
                background-size: 100% 100%;
              }
            }
          }
        }
      }
    }

    .match::-webkit-scrollbar {
      display: none
    }
  }

  .game-box {
    position: relative;
    left: 50%;
    transform: translate(-50%);
    width: 91.666vw;
    height: 48.888vw;
    margin: 3vw auto;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .icon-title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 5vw;
      margin-top: 3.333vw;

      img {
        width: auto;
        height: 5.555vw;
        margin-right: 2.222vw;
      }

      span {
        font-family: Inter;
        font-weight: 700;
        font-size: 4.444vw;
        text-transform: capitalize;
        color: #FFFFFF;
      }
    }

    .games {
      margin: 3vw auto 1.5vw auto;
      width: 87.2222vw;
      height: 22.5vw;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        width: 76.944vw;
        height: 22.5vw;
        border-radius: 1.111vw;
        background: radial-gradient(46.16% 50% at 50% 50%, rgba(0, 0, 0, 0.35) 0%, #000000 100%);
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .game {
          width: 25vw;
          height: 19vw;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          margin: 0 0 0 5vw;

          .img {
            width: 25vw;
            height: auto;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 1.111vw;
            box-shadow: 0 0 1.472vw 0 #426EFF8C;

            img {
              width: 25vw;
              height: auto;
            }
          }

          .name {
            font-family: Inter;
            font-weight: 700;
            font-size: 2.777vw;
            line-height: 100%;
            color: #656565;
            text-align: center;
          }
        }
      }

      .right {
        width: 8.8588vw;
        height: 22.5vw;
        line-height: 22.5vw;
        background: #000000;
        border-radius: 1.111vw;
        font-family: Arial;
        font-weight: 700;
        font-size: 3.333vw;
        text-transform: capitalize;
        color: #F4FFAA;
        text-align: center;
      }
    }

    .bottom {
      display: flex;
      flex-direction: column;
      height: 9.444vw;
      justify-content: space-between;
      padding-left: 3vw;

      .line1 {
        font-family: Inter;
        font-weight: 600;
        font-size: 3.888vw;
        line-height: 100%;
        color: #E2E2E2;
      }

      .line2 {
        font-family: Inter;
        font-weight: 400;
        font-size: 3.055vw;
        line-height: 100%;
        color: #929292;
      }
    }
  }

  .matchBox2 {
    position: relative;
    z-index: 6;
    width: 89.444vw;
    margin: -3.5vw auto 0 auto;

    .date-box {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      width: 91.666vw;
      height: 11.6666vw;
      line-height: 11.6666vw;
      border-radius: 1.9vw;
      padding: 0 3.5vw 0 5vw;
      background: radial-gradient(66.96% 255.96% at 94.26% -107.49%, rgba(23, 25, 29, 0.8) 0%, #1F2125 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */,
      linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(2, 86, 25, 0.2) 100%),
      linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(85, 85, 85, 0.2) 100%);
      display: flex;
      justify-content: space-between;

      .font {
        font-family: Inter;
        font-weight: 700;
        font-size: 4.16666vw;
        text-transform: capitalize;
        color: #FFFFFF;
      }

      .date {
        font-family: Inter;
        font-weight: 400;
        font-size: 3.333vw;
        text-transform: capitalize;
        color: #F8F8F8;
      }
    }

    .icon-title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 5vw;
      margin-top: 3.333vw;

      img {
        width: auto;
        height: 5.555vw;
        margin-right: 2.222vw;
      }

      span {
        font-family: Inter;
        font-weight: 700;
        font-size: 4.444vw;
        text-transform: capitalize;
        color: #FFFFFF;
      }
    }

    .event-box {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      margin: 5vw auto;
      width: 91.6667vw;
      min-height: 33.8889vw;
      border-radius: 2vw;
      background: rgba(34, 34, 34, 0.80);
      border: 0.333vw solid #3D3030;

      .content {
        margin: 2.35vw 0 2vw 5vw;
        width: 76vw;
        font-family: Inter;
        font-weight: 500;
        font-size: 3.333vw;
        line-height: 4.444vw;
        text-transform: capitalize;
        color: #8C8C8C;
      }
    }

    .reward-box {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      margin: 5vw auto;
      width: 91.6667vw;
      min-height: 42.222vw;
      border-radius: 2vw;
      background: #212528;
      border: 0.333vw solid #1F263D;

      .content {
        width: 82.5vw;
        margin: 2.35vw 0 0 5vw;
        font-family: Inter;
        font-weight: 500;
        font-size: 3.333vw;
        line-height: 4.444vw;
        text-transform: capitalize;
        color: #848484;
      }

      .button {
        margin: 3.5vw auto;
        width: 85vw;
        min-height: 8.3333vw;
        line-height: 8.3333vw;;
        border-radius: 1.111vw;
        text-align: center;
        background: #FFDD4A;
        font-family: Arial;
        font-weight: 700;
        font-size: 3.7vw;
        text-transform: capitalize;
        color: #000000;
      }
    }

  }

  .matchBox3 {
    position: relative;
    z-index: 6;
    width: 89.444vw;
    margin: -3.5vw auto 0 auto;

    .date-box {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      width: 91.666vw;
      height: 11.6666vw;
      line-height: 11.6666vw;
      border-radius: 1.9vw;
      padding: 0 3.5vw 0 5vw;
      background: radial-gradient(66.96% 255.96% at 94.26% -107.49%, rgba(23, 25, 29, 0.8) 0%, #1F2125 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */,
      linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(2, 86, 25, 0.2) 100%),
      linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(85, 85, 85, 0.2) 100%);
      display: flex;
      justify-content: space-between;

      .font {
        font-family: Inter;
        font-weight: 700;
        font-size: 4.16666vw;
        text-transform: capitalize;
        color: #FFFFFF;
      }

      .date {
        font-family: Inter;
        font-weight: 400;
        font-size: 3.333vw;
        text-transform: capitalize;
        color: #F8F8F8;
      }
    }

    .icon-title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 5vw;

      img {
        width: auto;
        height: 5.555vw;
        margin-right: 2.222vw;
      }

      span {
        font-family: Inter;
        font-weight: 700;
        font-size: 4.444vw;
        text-transform: capitalize;
        color: #FFFFFF;
      }
    }

    .event-box {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      margin: 5vw auto;
      width: 91.6667vw;
      min-height: 33.5vw;
      height: max-content;
      border-radius: 2vw;
      background: rgba(34, 34, 34, 0.80);
      border: 0.333vw solid #3D3030;

      .content {
        margin: 0 0 0 5vw;
        width: 58.055vw;
        height: max-content;
        color: #9E9E9E;
        font-family: Inter;
        font-weight: 400;
        font-size: 3.61vw;
        line-height: 4.444VW;
        text-transform: capitalize;
      }

      .shadowImg1 {
        position: absolute;
        top: 52%;
        transform: translateY(-50%);
        right: 2vw;
      }

      .shadowImg2 {
        position: absolute;
        top: 62%;
        transform: translateY(-50%);
        right: 1.2vw;
      }

      .next {
        margin: 2.5vw 5vw;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .routeFonts {
          font-family: Inter;
          font-weight: 500;
          font-size: 3.472vw;
          text-transform: capitalize;
          color: #D9D9D9;
        }

        img {
          width: 3.333vw;
          height: auto;
          margin-left: 2vw;
          margin-top: 0.5vw;
        }
      }
    }

  }

  .tgBenefits {
    position: relative;
    background: radial-gradient(76.9% 61.11% at 47.59% -36.64%, rgba(9, 15, 20, 0) 0%, rgba(33, 34, 36, 0.95) 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */,
    linear-gradient(360deg, rgba(0, 0, 0, 0) 0%, rgba(73, 186, 116, 0.092) 136.43%),
    linear-gradient(120.27deg, rgba(255, 255, 255, 0) 6.45%, rgba(0, 0, 0, 0.2) 79.41%),
    linear-gradient(2.33deg, rgba(0, 0, 0, 0) -26.11%, rgba(10, 22, 3, 0.66) 98.04%);
    margin: 0 auto 0 auto;
    width: 94.1666vw;
    min-height: 104vw;
    border-radius: 1.9vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 6;
    padding: 5vw 0 7vw 0;

    .top {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      width: 75vw;
      height: 8vw;
      line-height: 8vw;
      text-align: center;

      span {
        position: relative;
        z-index: 1;
        font-family: Inter;
        font-weight: 800;
        font-size: 5.278vw;
        line-height: 100%;
        text-align: center;
        text-transform: uppercase;
        color: #FFFFFF;
      }

      img {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        z-index: 0;
      }
    }

    .center {
      display: flex;
      flex-direction: column;

      .row {
        position: relative;
        left: 50%;
        transform: translate(-50%);
        width: 73vw;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        height: max-content;
        margin-bottom: 4vw;

        .font {
          font-family: Inter;
          font-weight: 600;
          font-size: 3.055vw;
          line-height: 3.055vw;
          text-align: center;
          text-transform: capitalize;
          color: #EBEBEB;
          white-space: nowrap;
        }

        .type0 {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 24.166vw;
          height: 25.833vw;
          margin: 0 0 0 1vw;

          img {
            width: 17.925vw;
            height: auto;
          }
        }

        .type1 {
          margin: 3vw 0 0 23.5vw;
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 22.7777vw;
          height: 27.777vw;

          img {
            width: 17.408vw;
            height: auto;
          }
        }

        .type2 {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 26.944vw;
          height: 25.277vw;

          img {
            width: 17.6166vw;
            height: auto;
          }
        }

        .type3 {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 38.611vw;
          height: 23.333vw;
          margin: 3vw 0 0 13vw;

          img {
            width: 17.408vw;
            height: auto;
          }
        }
      }
    }

    .bottom {
      width: 100%;
      padding-top: 5vw;
      display: flex;
      justify-content: space-evenly;
      align-items: center;

      .button {
        width: 44vw;
        height: 10.55vw;
        border-radius: 1.11vw;
        background: #29ABEE;
        font-family: Arial;
        font-weight: 700;
        font-size: 3vw;
        line-height: 10.55vw;
        text-transform: capitalize;
        color: #FFFFFF;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        white-space: nowrap;
        letter-spacing: -0.005em;

        img {
          width: auto;
          height: 3.5vw;
        }
      }
    }
  }

  .otherRound {
    width: 89.444vw;
    background-color: #161616;
    margin: auto;

    .round-row {
      position: relative;
      display: flex;
      justify-content: space-between;
      background-position: center;
      background-repeat: no-repeat;
      height: max-content;
      margin: 5vw auto;
      border-radius: 5px;

      .dot {
        background-color: #FFC810;
        position: absolute;
        left: 5px;
        top: 5px;
        width: 2.45vw;
        height: 2.45vw;
        border-radius: 1.43vw;
      }

      .row_item {
        position: relative;
        width: 29.8vw;
        height: 22.5vw;
        overflow: hidden;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;

        .center-text {
          position: relative;
          top: 50%;
          transform: translateY(-50%);
          width: 100%;
          margin: auto;
          height: max-content;
          text-align: center;
          color: #FFFFFF;

          p:first-of-type {
            font-size: 4.444vw;
            font-weight: 400;
            line-height: 6.34vw;
          }

          p:last-of-type {
            font-size: 4.5vw;
            font-weight: 400;
            line-height: 3.888vw;
          }
        }

        .imgTeam {
          position: relative;
          top: 2vw;
          left: 50%;
          transform: translate(-50%);
          height: 13.333vw;
        }

        .imgBk-Center {
          position: absolute;
          top: 23%;
          width: 100%;
        }

        .text {
          display: flex !important;
          justify-content: center;
          align-items: center;
          margin: 0 auto 3.5vw auto;
          width: 100%;
          height: 8.46vw;
          text-align: center;
          font-size: 4.16vw;
          font-weight: 400;
          line-height: 4.16vw;
          color: #FFFFFF;
        }
      }
    }
  }

  .title-container {
    width: 100%;
    height: max-content;
    border-bottom: 0.4vw solid black;
  }

  .titleWhite {
    width: 100%;
    font-size: 5vw;
    line-height: 5vw;
    color: #ffffff;
    text-align: left;
    margin-left: 3vw;
    font-weight: 700;
  }

  .titleSmall {
    width: 100%;
    font-weight: 400;
    line-height: 10vw;
    color: #ffffff;
    text-align: center;
    font-size: 5vw;
  }

  .rankPage {
    position: relative;
    left: 50%;
    transform: translate(-50%);
    width: 90vw;
    min-height: 138.889vw;
    border-radius: 1.388vw;
    overflow: hidden;
    background: radial-gradient(68.7% 68.7% at 16.49% 31.3%, #222427 0%, #1B1E22 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
    z-index: 6;

    .lockBox {
      position: absolute;
      top: 13.888vw;
      right: 0;
      left: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.8);
      z-index: 1;
      border-radius: 1.9vw;
      display: flex;
      align-items: center;
      justify-content: center;

      .lockFill {
        width: 80vw;
        height: max-content;

        img {
          position: relative;
          left: 50%;
          transform: translate(-50%);
          width: 14.444vw;
          height: auto;
        }

        .text {
          width: 100%;
          font-family: Inter;
          font-weight: 800;
          font-size: 3.8vw;
          line-height: 4vw;
          text-align: center;
          text-transform: capitalize;
          color: #FFFFFF;
        }
      }
    }

    .betRank {
      z-index: 2;
      width: 100%;
      height: 13.8888vw;
      box-shadow: 0 1.666vw 5.555vw 0 #00000099;

      .RankBox {
        display: flex;
        width: 100%;
        height: 100%;
        padding: 0 4vw;
        align-items: center;
        justify-content: space-between;

        .myRank {
          font-size: 4.166vw;
          font-weight: 800;
          text-align: left;
          color: #FFFFFF;
          letter-spacing: -0.08em;
          white-space: nowrap;
        }

        .seeReward {
          font-size: 3.611vw;
          font-weight: 600;
          color: #00BBFF;
          width: max-content;
          border-bottom: 1px solid #00BBFF;
          letter-spacing: -0.07em;
          white-space: nowrap;
          font-family: Inter;
        }
      }
    }

    .RankList {
      margin: 0 auto 5vw auto;
      width: 90vw;
      height: 123.05vw;
      padding-bottom: 5vw;
      overflow-x: hidden;
      overflow-y: auto;

      .RankRow {
        width: 95%;
        display: flex;
        height: 13.055vw;
        margin: 3vw auto;
        justify-content: space-between;
        align-items: center;
        font-size: 4.166vw;
        font-weight: 400;
        color: #FFFFFF;
        text-align: left;
        border-radius: 5px;

        .rankImg {
          margin: 0 1vw 0 3vw;
          width: 8.88vw;
          text-align: center;
          color: #9E9E9E;
          display: flex;
          justify-content: center;

          img {
            width: 100%;
          }
        }

        .name {
          width: 43vw;
          padding-left: 2vw;
          word-wrap: break-word;
        }

        .amount {
          padding-right: 2.3vw;
          width: 24.13vw;
          text-align: center;
          word-wrap: break-word;
        }
      }

      .RankRow:first-of-type {
        margin: 0 auto;
      }

      #rank0 {
        margin: 0 auto;
      }
    }

  }

  .lastWeek {
    margin: 2vw 0 0 0;
    position: relative;
    left: 50%;
    transform: translate(-50%);
    width: 90vw;
    height: max-content;
    text-transform: capitalize;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    z-index: 6;

    .part1 {
      border-radius: 2vw 2vw 0 0;
      width: 100%;
      height: 10.833vw;
      line-height: 10.833vw;;
      display: flex;
      justify-content: space-between;
      background: #242424;
      box-shadow: 0 1.666vw 5.555vw 0 #00000099;
      padding: 0 3vw 0 3.888vw;

      .text1 {
        font-family: Inter;
        font-weight: 800;
        font-size: 4.166vw;
        color: #FFFFFF;
      }

      .text2 {
        font-family: Inter;
        font-weight: 600;
        font-size: 3.611vw;
        text-decoration: underline;
        color: #00BBFF;
      }
    }

    .part2 {
      border-radius: 0 0 2vw 2vw;
      width: 100%;
      height: 11.388vw;
      line-height: 11.388vw;
      display: flex;
      justify-content: space-between;
      background: #2D2D2D;
      padding: 0 3vw 0 3.888vw;

      .text1 {
        font-family: Inter;
        font-weight: 800;
        font-size: 3.611vw;
        text-transform: capitalize;
        color: #FFFFFF;
      }

      .text2 {
        font-family: Inter;
        font-weight: 800;
        font-size: 3.611vw;
        color: #FDFF6C;
      }
    }
  }

  .bottom-rules {
    width: 100vw;
    text-align: center;

    img {
      width: 16.66vw;
      height: 2.61vh;
    }

    .bubble-box {
      margin: 3vw auto;
      width: 91.111vw;
      height: max-content;
      opacity: 0.95;
      border-radius: 2vw;
      border: 1px solid #46382B;
      padding: 5vw 0;
      background: rgba(34, 34, 34, 0.99);

      .bubbleContent {
        display: flex;
        margin: auto;
        padding: 0 2vw;
        width: 88vw;
        text-align: left;
        white-space: pre-wrap;
        font-family: Inter;
        font-weight: 500;
        font-size: 3.888vw;
        text-transform: capitalize;
        color: #848484;
      }
    }
  }

  .panel-Mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .7);
    z-index: 101;
  }

  .panel {
    position: fixed;
    bottom: 0;
    width: 100vw;
    z-index: 102;

    .grips {
      margin: 0 auto 3.68vw auto;
      background: #E0E2E4;
      width: 19vw;
      height: 2.05vw;
      border-radius: 1.84vw;
    }

    .panel_background {
      background-color: #1F2022;
      padding: 5vw 3.5vw;
      border: 1.5px solid #3C3D40;
      border-bottom: none;
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
      width: 100%;
      height: max-content;

      .team-wrapper {
        margin: 2.5vw auto 2vw auto;
        height: 46.63vw;
        display: flex;
        justify-content: space-between;

        .pie {
          position: relative;
          margin: 3.5vw auto 1vw auto;
          width: 18vw;
          height: 18vw;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            position: absolute;
            height: 60%;
            max-width: 65%;
          }

          .circle {
            background-repeat: no-repeat;
            background-position: center;
            background-size: 100% 100%;
            width: 17.4vw;
            height: 17.4vw;
          }
        }

        .choose-item {
          width: 29vw;
          height: max-content;
          background-color: #171717;
          border: 1.8px solid #3D3D3D;
          border-radius: 5px;

          p {
            margin: 0 0 0.5vw 0;
            width: calc(29vw - 3.6px);
            text-align: center;
            font-size: 3.25vw;
            font-weight: 400;
            line-height: 3.25vw;
            color: #FFFFFF;
          }

          .team-name {
            margin: 0 0 1vw 0;
            width: calc(29vw - 3.6px);
            text-align: center;
            font-size: 4.166vw;
            font-weight: 400;
            line-height: 4.166vw;
            height: 5.25vw;
            color: #FFFFFF;
          }
        }

        .active-choose {
          border: 1.85px solid #FFFFFF !important;
        }

        .guess-bottom {
          margin: 4vw auto 2.22vw auto;
          border-radius: 18px;
          padding: 5px 0 2px 0;
          text-align: center;
          width: 25.833vw;
          overflow: hidden;

          p {
            width: 100%;
            margin: 0 auto;
            font-size: 3.055vw;
            font-weight: 400;
            line-height: 4vw;
          }
        }
      }

      .team-wrapper2 {
        margin: 2vw auto 0 auto;
        display: flex;
        width: 88.14vw;
        height: 20.277vw;
        background-color: #171717;
        border-radius: 2.77vw;
        border: 1px solid #3D3D3D;
        align-items: center;
        padding-left: 4vw;

        .teamImg {
          position: relative;
          width: 14.166vw;
          height: 14.166vw;
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;

          .imgBk {
            position: absolute;
            top: 0;
            width: 14.166vw;
            height: 14.166vw;
          }

          .imgInner {
            position: relative;
            max-width: 58.5%;
            max-height: 58.5%;
          }
        }

        .teamChoose {
          margin-left: 3vw;
          text-align: left;

          p {
            font-size: 5vw;
            font-weight: 400;
            color: #FFFFFF;
          }
        }
      }

      .subtitle {
        margin-top: 3vw;
        margin-left: 3vw;
        margin-bottom: 0;
        font-weight: 400;
      }

      .tips {
        margin: 3vw auto 0 auto;
        width: 100%;

        p {
          font-size: 4.3vw;
          font-weight: 400;
          line-height: 4.9vw;
          color: #FFFFFF;
        }

        p:last-of-type {
          position: relative;
          font-size: 3.88vw;
          line-height: 4.5vw;
          display: flex;
          color: #5A5A5A;

          img {
            position: absolute;
            height: 3.88vw;
            left: 0;
            bottom: 2px;
          }

          span {
            margin-left: 5vw;
          }
        }
      }

      .yellow-button {
        background-color: #FFDD4A;
        color: #000000;
        width: 85.9vw;
        margin: 5vw auto 3vw auto;
        text-align: center;
        font-size: 5.277vw;
        font-weight: 700;
        height: 11.388vw;
        line-height: 11.388vw;
        border-radius: 5px;
      }

      .disabled-button {
        background-color: #838383;
        color: #000000;
        width: 85.9vw;
        margin: 5vw auto 3vw auto;
        text-align: center;
        font-size: 6.13vw;
        font-weight: 400;
        line-height: 12.88vw;
        height: 12.88vw;
        border-radius: 5px;
      }

      p {
        margin: 1vw 3vw;
        font-size: 3.888vw;
        font-weight: 400;
        line-height: 4.9vw;
      }
    }
  }

  .share-alert {
    position: fixed;
    top: 35vh;
    left: 4vw;
    width: 92vw;
    height: max-content;
    border: 2px solid #737373;
    border-radius: 15px;
    background: linear-gradient(0deg, #1C1C1E, #1C1C1E), linear-gradient(0deg, #737373, #737373);
    z-index: 102;

    .title {
      margin-top: 2.5vw;
      font-size: 7.56vw;
      font-weight: 400;
      text-align: center;
      color: #FFFFFF;
    }

    .subTitle {
      width: 92%;
      margin: 3vw auto;
      font-size: 4.25vw;
      font-weight: 400;
      text-align: left;
      color: #BABABA;
    }

    .subTip {
      display: flex;
      margin: 4.5vw auto 6.5vw auto;
      justify-content: space-between;
      font-size: 5.52vw;
      height: 6vw;
      font-weight: 400;
      text-align: center;
      color: #FFFFFF;

      div {
        white-space: nowrap;
      }
    }

    .close {
      position: absolute;
      top: 5.5vw;
      right: 5vw;
      width: 17px;
    }

    .otherIcon {
      display: flex;
      margin: 5vw 0;
      width: 92%;
      font-size: 3.8vw;

      div {
        width: 23vw;
        text-align: center;
        color: #A3A3A3;
        font-weight: 400;

        img {
          width: 16vw;
          margin-left: 0.5vw;
        }

        .telegram {
          width: 15.5vw;
        }

        .whatsapp {
          width: 15.5vw;
        }
      }
    }
  }

  .cancel-btn {
    top: -10vw;
    right: -3vw;
    position: absolute;
    width: 5.13vw;
    margin-right: 3.333vw;
  }

  .rank-reward {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90vw;
    height: 137.777vw;
    background: radial-gradient(68.7% 68.7% at 16.49% 31.3%, #222427 0%, #1B1E22 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
    z-index: 102;
    border-radius: 2vw;
    box-shadow: 0 1.6666vw 5.5555vw 0 #00000099;

    .reward-table {
      color: #FFFFFF;
      margin-top: 1.5vw;
      padding: 1.5vw 0;

      .title {
        position: relative;
        left: 50%;
        transform: translate(-50%);
        display: flex;
        justify-content: space-between;
        font-size: 4.1666vw;
        width: 82.5vw;
        font-weight: 700;
        margin: 0.5vw 0 4vw 0;

        div {
          width: 50%;
          text-align: center;
        }
      }

      .title div:nth-child(1) {
        text-align: left;
        padding-left: 10vw;
      }

      .tbody {
        width: 100%;
        height: 120vw;
        overflow-x: hidden;
        overflow-y: auto;

        img {
          width: 8.888vw;
          height: auto;
        }

        .tr {
          margin: 2vw auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 4.1666vw;
          width: 82.5vw;
          height: 13.05vw;
          border-radius: 1.3888vw;
          padding-right: 1vw;
          background: #323438;
          box-shadow: 0 1vw 2vw 0 #00000040;
        }

        .tr div:nth-child(1) {
          color: #9E9E9E;
          width: 42%;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .tr div:nth-child(2) {
          color: #FFFFFF;
          width: 50%;
          text-align: center;
        }
      }
    }
  }
}

.w-textShadow {
  //-webkit-text-stroke:3px transparent;
  //background: #FFFFFF top left / 100% 100%;
  //-webkit-background-clip: text;
  font-size: 4.443vw;
  font-weight: 900;
  line-height: 5.277vw;
  letter-spacing: -0.03em;
  text-align: center;
  color: #FFFFFF;
}

.lastWeekList {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  background: rgba(0, 0, 0, 0.75);
  z-index: 7;

  .closeLastWeekButton {
    position: relative;
    left: 50%;
    transform: translate(-50%);
    top: 30vw;
    width: 86vw;
    display: flex;
    justify-content: flex-end;

    img {
      width: 4.166vw;
      height: 4.166vw;
    }
  }

  .lastWeekModal {
    position: relative;
    left: 50%;
    transform: translate(-50%);
    top: 33vw;
    width: 90vw;
    height: 152.7vw;
    background: radial-gradient(68.7% 68.7% at 16.49% 31.3%, #222427 0%, #1B1E22 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
    border-radius: 1.111vw;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .shadow {
      position: absolute;
      top: 14.1361vw;
      left: 0;
      width: 100%;
      height: 138.5vw;
      box-shadow: inset 0 3vw 5.555vw 0 rgba(0, 0, 0, 0.85);
      z-index: 0;
    }

    .top {
      position: relative;
      width: 100%;
      height: 14.1361vw;
      background: #242424;
      border-radius: 1.111vw 1.111vw 0 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 4.444vw;
      overflow: hidden;

      .title {
        font-family: Inter;
        font-weight: 800;
        font-size: 4.166vw;
        line-height: 100%;
        text-align: center;
        text-transform: capitalize;
        color: #FFFFFF;
      }
    }

    .lastRankList {
      position: relative;
      width: 100%;
      height: 120vw;
      overflow-x: hidden;
      overflow-y: auto;

      .RankRow {
        width: 95%;
        display: flex;
        height: 13.055vw;
        margin: 3vw auto;
        justify-content: space-between;
        align-items: center;
        font-size: 4.166vw;
        font-weight: 400;
        color: #FFFFFF;
        text-align: left;
        border-radius: 5px;
        padding-left: 7.5vw;

        .rankImg {
          margin: 0 1vw 0 3vw;
          width: 8.88vw;
          text-align: center;
          color: #9E9E9E;
          display: flex;
          justify-content: center;

          img {
            width: 100%;
          }
        }

        .name {
          width: 43vw;
          padding-left: 2vw;
          word-wrap: break-word;
          text-align: center;
        }
      }

      .RankRow:first-of-type {
        margin: 0 auto;
      }

      #rank0 {
        margin: 0 auto;
      }
    }

    .myRankLastWeek {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%);
      width: 95%;
      display: flex;
      height: 13.055vw;
      margin: 3vw auto;
      justify-content: space-between;
      align-items: center;
      font-size: 4.166vw;
      font-weight: 400;
      color: #FDFF6C;
      text-align: left;
      border-radius: 5px;
      padding-left: 7.5vw;
      background: #756310;

      .name {
        width: 43vw;
        padding-left: 2vw;
        word-wrap: break-word;
        text-align: center;
      }

      .rankImg {
        margin: 0 1vw 0 3vw;
        width: 8.88vw;
        text-align: center;
        display: flex;
        justify-content: center;
        font-size: 4.166vw;

        img {
          width: 100%;
        }
      }
    }
  }
}

.main-content::-webkit-scrollbar {
  display: none
}

.RankList::-webkit-scrollbar {
  display: none
}

.lastRankList::-webkit-scrollbar {
  display: none
}

/deep/ .mint-swipe-indicators {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/SportsBetting/index.vue